var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app app1",attrs:{"id":"app"}},[_c('a-layout',[_c('global-header'),_c('a-layout-content',[_c('keep-alive',{attrs:{"exclude":"Detail"}},[_c('router-view')],1)],1),_c('global-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }